import GroupsActionsCell from "../../components/users/partials/GroupsActionsCell";

/**
 * This map contains the mapping between the template strings above and the corresponding react component.
 * This helps to render different templates of cells more dynamically. Even empty needed, because Table component
 * uses template map.
 */
export const groupsTemplateMap = {
	GroupsActionsCell: GroupsActionsCell,
};
